module.exports = ".social-card-img{background-image:url(/assets/img/dashboard/social_new.jpg)}.widget-11-2 .widget-11-2-table{height:273px}\n"